import { FormProps } from "view/inputs/Form";
import { FormElementProps } from "view/inputs/Input";
import Free from "./Free";

export default function Mail(props: FormProps & FormElementProps) {
  const { ...inputProps } = props;

  return <Free type="email" {...inputProps} />;
}
